import React from 'react';
import './style.scss';
import AddHeader from '../../../../components/layout/header/add';
import Forms from '../../../../components/molecules/forms';
import { Menu, SixSquare } from '../../../../components/atoms/icons';
import RenderPlanogram from './RenderPlanogram';
import useVmPlanogram, { PlanogramData } from './hooks';
import { QR_URL } from '../../../../config/envConf';
import RenderModal from './RenderModal';
import Stepper from '../../../../components/molecules/steppers';
/* eslint-disable */
function VMPlanogram() {
  const {
    planogramList, planogramClientList, planogramListLoading, searchValue, onChangeSearch,
    currentMode, setCurrentMode, vmData, afterUpdateVmColumn, loadingUpdateVmColumn,
    resultUpdateVmColumn, vmId, resultDeleteProduct, afterDeleteProduct, handleDeleteProduct,
    loadingDeleteProduct, formik, optionsFetcher, productSearchInput, setProductSearchInput, loadingUpdateCopyPlanogram,
    handleChangeSelectedProduct, selectedProduct, onInitModalEdit, isCoffee, isWholesale, onInitModalCopy, afterCopyVmColumn,
    activeClient, activeVM, selectedVMID, handleSelected, handleSelectedVM, handleSelectedVMCopy, resultCopyVmColumn
  } = useVmPlanogram();

  const renderModalDelete = (item: PlanogramData): React.ReactElement => (
    <RenderModal.Delete
      handleDeleteProduct={handleDeleteProduct}
      resultDeleteProduct={resultDeleteProduct}
      afterDeleteProduct={afterDeleteProduct}
      loadingDeleteProduct={loadingDeleteProduct}
      item={item}
    />
  );

  const renderModalUpdate = (item: PlanogramData): React.ReactElement => (
    <RenderModal.Update
      formik={formik}
      resultUpdateVmColumn={resultUpdateVmColumn}
      afterUpdateVmColumn={afterUpdateVmColumn}
      loadingUpdateVmColumn={loadingUpdateVmColumn}
      handleChangeInput={(e) => setProductSearchInput(e)}
      inputValue={productSearchInput}
      item={item}
      optionsFetcher={optionsFetcher}
      handleChangeSelectedProduct={handleChangeSelectedProduct}
      selectedProduct={selectedProduct!}
      onInitModalEdit={onInitModalEdit}
    />
  );

  const renderModalCopy = (): React.ReactElement => (
    <RenderModal.Copy
      planogramClientList={planogramClientList}
      activeClient={activeClient}
      activeVM={activeVM}
      selectedVMID={selectedVMID}
      handleSelected={handleSelected}
      handleSelectedVM={handleSelectedVM}
      handleSelectedVMCopy={handleSelectedVMCopy}
      onInitModalCopy={onInitModalCopy}
      resultCopyVmColumn={resultCopyVmColumn}
      afterCopyVmColumn={afterCopyVmColumn}
      loadingUpdateCopyPlanogram={loadingUpdateCopyPlanogram}
    />
  );

  return (
    <div>
      <AddHeader
        primary={isCoffee ? { title: 'Coffee Machine', route: '/coffee-machine' } : isWholesale ? { title: 'Wholesale Distribution', route: '/coffee-machine' } : { title: 'Vending Machine', route: '/vending-machine' }}
        title={vmData?.deviceId}
      />
      <div className={vmData ? 'd-flex align-items-center fz-14 ps-4 ps-xl-5 mb-4' : 'd-none'}>
        <img src={`${QR_URL}${vmId}_qr.png`} alt="qrImg" width={100} className="me-2 me-lg-3 me-xl-4" />
        <div className="me-2 me-lg-3 me-xl-4">
          <div className="color-placeholder fw-bold mb-1">DEVICE ID</div>
          <div>{vmData?.deviceId}</div>
        </div>
        <div className="me-2 me-lg-3 me-xl-4">
          <div className="color-placeholder fw-bold mb-1">MACHINE MODEL</div>
          <div>{vmData?.model}</div>
        </div>
        <div className="me-2 me-lg-3 me-xl-4">
          <div className="color-placeholder fw-bold mb-1">CLIENT</div>
          <div>{vmData?.clientName}</div>
        </div>
        <div className="me-2 me-lg-3 me-xl-4">
          <div className="color-placeholder fw-bold mb-1">LOCATION</div>
          <div>{vmData?.location}</div>
        </div>
      </div>
      <div className="w-100 bg-stroke" style={{ height: '1px' }} />
      <div className="d-flex justify-content-between px-4 px-xl-5 py-4">
        <div className="flex-grow-1 me-2 me-xl-4" style={{ maxWidth: '600px', height: '42px' }}>
          <Forms.Search
            placeholder="Search"
            onChange={(e) => onChangeSearch(e.target.value)}
            value={searchValue}
          />
        </div>
        <div className="d-flex align-items-center">
          {renderModalCopy()}
          <div style={{ height: '42px', width: '90px' }}>
            <Stepper.Switch
              currentMode={currentMode}
              setCurrentMode={setCurrentMode}
              content={{
                1: (<SixSquare />),
                2: (<Menu />),
              }}
            />
          </div>
        </div>
      </div>
      <RenderPlanogram
        planogramList={planogramList}
        planogramListLoading={planogramListLoading}
        mode={currentMode}
        renderModalUpdate={renderModalUpdate}
        renderModalDelete={renderModalDelete}
      />
    </div>
  );
}

export default VMPlanogram;
